import { Task } from "@/_models/task.interface";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-task-card",
    standalone: true,
    imports: [
        CommonModule,
        SharedComponentsModule,
        CombinedTaskCardMobileComponent,
        RouterModule,
    ],
    templateUrl: "./task-card.component.html",
    styleUrls: [
        "./task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class TaskCardComponent {
    @Input() task: Task;
    @Input() showEdit: boolean = false;
    @Input() isLast: boolean = false;

    constructor(public dateUtils: DateUtils) {}

    getTaskTitle(): string {
        return this.task.title || "Untitled Task";
    }

    getTaskDueDate(): Date {
        return this.task.dueDate;
    }

    getTaskStatus(): string {
        return this.task.status || "active";
    }

    hasAssociations(): boolean {
        return (
            (this.task.relatedFlights && this.task.relatedFlights.length > 0) ||
            (this.task.relatedIssues && this.task.relatedIssues.length > 0) ||
            this.getTotalAssociations() > 0
        );
    }

    getTotalAssociations(): number {
        const flightCount = this.task.relatedFlights?.length || 0;
        const issueCount = this.task.relatedIssues?.length || 0;
        return flightCount + issueCount;
    }
}
